import React from 'react';
import { cn } from 'utils/cn';

const DOCK_POSITION_CLASS =
  'left-3 sm:left-4 lg:left-[calc(15rem+1rem)] bottom-[calc(0.75rem+env(safe-area-inset-bottom,0px))]';

const EditorAssistFloatingDock = ({ neoAiPanel, className }) => (
  <div
    className={cn(
      'fixed z-[1100] flex items-end gap-2',
      DOCK_POSITION_CLASS,
      className
    )}
  >
    <div className="min-w-0 shrink-0">{neoAiPanel}</div>
  </div>
);

export default EditorAssistFloatingDock;
